/* AWP new homepage behaviour. Videos play on the page; Add to cart uses the theme's cart drawer. */
(function () {
  var root = document.querySelector('.awp-home');
  if (!root) return;

  /* ---------- hero: the loop becomes the player in place ---------- */
  var hp = document.getElementById('v3hp'), slot = document.getElementById('v3vid'),
      go = document.getElementById('v3go'), cl = document.getElementById('v3close'),
      loop = hp ? hp.querySelector('.loop') : null;
  function ended() {
    hp.classList.add('ended');
    var c = document.getElementById('v3cases');
    if (c) c.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  /* The story video is hosted on Shopify, so play() runs inside the tap itself
     and phones start it on the first tap. */
  if (hp && slot && go) {
    slot.addEventListener('ended', ended);
    go.addEventListener('click', function (e) {
      e.preventDefault();
      if (window.innerWidth >= 760) hp.style.height = hp.offsetHeight + 'px';
      hp.classList.remove('ended');
      hp.classList.add('playing');
      if (loop) try { loop.pause(); } catch (x) {}
      slot.muted = false;
      try { slot.currentTime = 0; } catch (x) {}
      var pr = slot.play();
      if (pr && pr.catch) pr.catch(function () {});
      if (window.innerWidth < 760) setTimeout(function () { hp.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 320);
    });
    function close() {
      slot.pause();
      hp.style.height = '';
      hp.classList.remove('playing', 'ended');
      if (loop) try { loop.play(); } catch (x) {}
    }
    if (cl) cl.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && hp.classList.contains('playing')) close(); });
  }

  /* ---------- story cards: play on AWP in a player window ---------- */
  var modal = document.getElementById('awp-ytm');
  if (modal) {
    var frame = modal.querySelector('.awp-ytm-f'), lastFocus = null;
    function openYT(id) {
      lastFocus = document.activeElement;
      frame.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&playsinline=1&rel=0&modestbranding=1" title="Video" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      modal.querySelector('[data-ytm-close]').focus();
    }
    function closeYT() {
      modal.hidden = true;
      frame.innerHTML = '';
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    root.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-yt]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      openYT(a.getAttribute('data-yt'));
    });
    modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('[data-ytm-close]')) closeYT(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeYT(); });
  }

  /* ---------- K9 video ---------- */
  root.querySelectorAll('[data-k9]').forEach(function (w) {
    var b = w.querySelector('.t3play'), v = w.querySelector('video');
    if (b && v) b.addEventListener('click', function () { b.hidden = true; v.controls = true; v.play(); });
  });

  /* ---------- window breaker: color, pack, add to cart ---------- */
  var tool = document.getElementById('v3tool');
  var data = null;
  try { data = JSON.parse(document.getElementById('awp-wb').textContent); } catch (e) {}
  if (!tool) return;
  var cn = tool.querySelector('[data-cn]'), atc = tool.querySelector('[data-atc]'), err = tool.querySelector('[data-err]');
  var color = 'Red';
  tool.querySelectorAll('.t3sw').forEach(function (b) {
    if (b.classList.contains('on')) color = b.dataset.n;
    b.addEventListener('click', function () {
      tool.querySelectorAll('.t3sw').forEach(function (x) { x.classList.toggle('on', x === b); });
      var sp = tool.querySelector('.t3spin');
      tool.querySelectorAll('.t3pic img').forEach(function (im) { im.hidden = im.dataset.c !== b.dataset.c || (sp && b.dataset.c === 'red'); });
      if (sp) { sp.hidden = b.dataset.c !== 'red'; if (!sp.hidden) sp.play(); }
      color = b.dataset.n;
      var cnl = tool.querySelector('[data-cn]'); if (cnl) cnl.textContent = b.dataset.n;
    });
  });
  tool.querySelectorAll('.t3pk').forEach(function (p) {
    p.addEventListener('click', function () {
      tool.querySelectorAll('.t3pk').forEach(function (x) { x.classList.toggle('on', x === p); });
    });
  });

  /* Local money (Oct 24 2026): shoppers paying in another currency see the packs in their money, the same as checkout.
     CA, AU and NZ: 3+ breakers = the US price each x Shopify's rate, moved to the closest .95 (BreakerDeal Abroad).
     Other currencies: the local price less 1 or 2 each (BreakerDeal). No local compare-at = no strike price and no "You save". */
  var cur = ((window.Shopify || {}).currency || {}).active || 'USD';
  var mf = ((window.theme || {}).settings || {}).moneyFormat || '${{amount}}';
  /* a "$" outside USD gets its country letters (CA$, A$, NZ$) so no one mistakes it for US dollars */
  var dsym = { CAD: 'CA$', AUD: 'A$', NZD: 'NZ$' }[cur] || cur.slice(0, 2) + '$';
  var money = function (c, short) {
    c = Math.round(c);
    var d = short && c % 100 === 0 ? String(c / 100) : (c / 100).toFixed(2), pp = d.split('.');
    var g = function (x, t) { return x.replace(/\B(?=(\d{3})+(?!\d))/g, t); };
    var r = mf.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (/no_decimals/.test(k)) return g(String(Math.round(c / 100)), /comma/.test(k) ? '.' : ',');
      var cm = /comma_separator/.test(k);
      return g(pp[0], cm ? '.' : /apostrophe/.test(k) ? "'" : ',') + (pp[1] ? (cm ? ',' : '.') + pp[1] : '');
    });
    return cur !== 'USD' ? r.replace('$', dsym) : r;
  };
  /* shipping is only free in the US */
  if (((window.Shopify || {}).country || 'US') !== 'US') tool.querySelectorAll('.t3pk .fs').forEach(function (x) { x.hidden = true; });
  if (data && data.price && cur !== 'USD') {
    var rate = +(((window.Shopify || {}).currency || {}).rate) || 0, list = data.price, cmp = data.compare > list ? data.compare : 0;
    var ab = /^(CAD|AUD|NZD)$/.test(cur) && rate > 0;
    var n95 = function (x) { var lo = Math.floor(x / 100) * 100 - 5; return x - lo <= lo + 100 - x ? lo : lo + 100; };
    var at = function (us, off) { return Math.min(list - off, ab ? n95(Math.round(us * rate)) : list); };
    var each = { 1: list, 2: list, 3: at(1895, 100), 5: at(1795, 200) };
    tool.querySelectorAll('.t3price').forEach(function (pr) {
      var s = pr.querySelector('s'), b = pr.querySelector('b'), off = pr.querySelector('.off'), pc = cmp ? Math.round((1 - list / cmp) * 100) : 0;
      if (s) { if (cmp) s.textContent = money(cmp); else s.hidden = true; }
      if (b) b.textContent = money(list);
      if (off) { if (pc > 0) off.textContent = 'Starting at ' + pc + '% off'; else off.hidden = true; }
    });
    tool.querySelectorAll('.t3pk').forEach(function (p) {
      var q = parseInt(p.dataset.q, 10), per = each[q] || list, total = per * q;
      var bs = p.querySelector('.pr b'), sm = p.querySelector('.pr small'), ys = p.querySelector('.pm .ys');
      if (bs) bs.textContent = money(total);
      if (sm) { if (q < 2) sm.hidden = true; else sm.textContent = money(per) + ' each'; }
      if (ys) { if (cmp && cmp * q > total) ys.textContent = 'You save ' + money(cmp * q - total); else ys.hidden = true; }
      p.querySelectorAll('.bdg.svd, .bdg.svm').forEach(function (x) { if (per < list) x.textContent = 'Save an extra ' + money(list - per, true) + ' each'; else x.hidden = true; });
      p.dataset.t = money(total);
    });
  }
  /* pack prices from the live price: dollars off each (off3, off5, in cents) to match BreakerDeal (automatic discount, Oct 24 2026); pct3/pct5 still work if set */
  else if (data && data.price) {
    var price = data.price / 100;
    var pct = { 1: 0, 2: 0, 3: data.pct3 || 0, 5: data.pct5 || 0 };
    var fmt = function (n) { return '$' + n.toFixed(2); };
    tool.querySelectorAll('.t3pk').forEach(function (p) {
      var q = parseInt(p.dataset.q, 10), per = data.off3 != null ? (data.price - ({ 3: data.off3, 5: data.off5 }[q] || 0)) / 100 : Math.round(price * (100 - (pct[q] || 0))) / 100, total = Math.round(per * q * 100) / 100;  /* checkout discounts each unit to the cent */
      var bs = p.querySelector('.pr b'), sm = p.querySelector('.pr small'), ys = p.querySelector('.pm .ys');
      if (bs) bs.textContent = fmt(total);
      if (sm) { if (q < 2) sm.hidden = true; else sm.textContent = fmt(per) + ' each'; }  /* Single shows its price once */
      /* You save counts from the compare-at: qty x compare-at minus pack total */
      if (ys) { var save = Math.round(((data.compare || 0) / 100 * q - total) * 100) / 100; if (save > 0) ys.textContent = 'You save ' + fmt(save); else ys.hidden = true; }
      p.dataset.t = fmt(total);
    });
  }

  function variantFor(colorName) {
    if (!data || !data.variants) return null;
    var want = colorName.toLowerCase().replace(/-/g, ' ');
    var v = data.variants.filter(function (x) { return x.name.toLowerCase() === want; })[0];
    return v && v.available ? v.id : null;
  }
  function openDrawer() {
    /* same steps the product page multipack uses to refresh and open the Motion cart drawer */
    return fetch('/cart?view=ajax', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) { return r.text(); }).then(function (html) {
      var drawer = document.getElementById('CartDrawer');
      if (!drawer) throw new Error('no drawer');
      var doc = new DOMParser().parseFromString(html, 'text/html'), items = doc.querySelector('.cart__items'), disc = doc.querySelector('.cart__discounts');
      if (!items) throw new Error('no items');
      var box = drawer.querySelector('[data-products]');
      if (box) { box.innerHTML = ''; box.appendChild(items); }
      var dbox = drawer.querySelector('[data-discounts]');
      if (dbox && disc) dbox.innerHTML = disc.innerHTML;
      var sub = parseInt(items.getAttribute('data-cart-subtotal') || '0', 10), st = drawer.querySelector('[data-subtotal]');
      if (st) st.innerHTML = cur !== 'USD' ? money(sub) : '$' + (sub / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      var bubble = document.querySelector('.cart-link__bubble'), count = parseInt(items.getAttribute('data-count') || '0', 10);
      if (bubble && count > 0) bubble.classList.add('cart-link__bubble--visible');
      var t = document.querySelector('.js-drawer-open-cart');
      if (!t) throw new Error('no toggle');
      t.click();
    });
  }
  if (atc) atc.addEventListener('click', function () {
    if (err) err.hidden = true;
    var on = tool.querySelector('.t3pk.on'), qty = on ? parseInt(on.dataset.q, 10) : 1;
    /* one color per breaker (multi.js), grouped into cart lines */
    var colors = tool._colors ? tool._colors() : [color];
    while (colors.length < qty) colors.push(colors[colors.length - 1]);
    var count = {}, ids = {}, bad = null;
    colors.slice(0, qty).forEach(function (c) { var id = variantFor(c); if (!id) bad = bad || c; else { ids[c] = id; count[c] = (count[c] || 0) + 1; } });
    if (bad) { if (err) { err.hidden = false; err.textContent = 'Sorry, ' + bad + ' is sold out right now. Please pick another color.'; } return; }
    var items = Object.keys(count).map(function (c) { return { id: ids[c], quantity: count[c] }; });
    var label = atc.textContent;
    atc.disabled = true; atc.textContent = 'Adding...';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(openDrawer)
      .then(function () { atc.disabled = false; atc.textContent = label; })
      .catch(function () { window.location.href = '/cart'; });
  });
})();

/* Below-the-fold videos (Jacob memory loop, breaker 360) play only while on screen. If a phone blocks autoplay
   (Low Power Mode, data saver), the 360 falls back to the red product photo instead of a blank frame. */
(function () {
  var vids = document.querySelectorAll('.awp-home video[data-inview]');
  if (!vids.length) return;
  function fallback(v) {
    if (!v.classList.contains('t3spin')) return;
    var still = v.parentNode.querySelector('img[data-still]');
    if (still && !v.hidden) { v.hidden = true; still.hidden = false; still.loading = 'eager'; }
  }
  function play(v) {
    v.muted = true; v.playsInline = true;
    if (v.preload !== 'auto') { v.preload = 'auto'; }
    var p = v.play();
    if (p && p.catch) p.catch(function (err) { if (err && err.name === 'NotAllowedError') fallback(v); });  /* an AbortError just means it was paused while scrolling past */
  }
  if (!('IntersectionObserver' in window)) { vids.forEach(play); return; }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) play(e.target); else if (!e.target.paused) e.target.pause(); });
  }, { rootMargin: '200px 0px' });
  vids.forEach(function (v) { io.observe(v); });
})();

/* Pack color picker: opens right under the selected pack, one row per breaker (like the product page multipack).
   Shared by the mockup and awp-home.js. */
(function () {
  var tool = document.getElementById('v3tool');
  if (!tool || tool._colors) return;
  var grid = tool.querySelector('.t3sws'), cl = tool.querySelector('.t3cl'), rows = tool.querySelector('.t3rows');
  if (!grid || !rows) return;
  var sw = [].slice.call(grid.querySelectorAll('.t3sw')).map(function (b) { return { c: b.dataset.c, n: b.dataset.n, img: b.dataset.row || b.querySelector('img').getAttribute('src') }; });
  var on0 = grid.querySelector('.t3sw.on'), picks = [on0 ? on0.dataset.c : 'red'];
  /* the big swatches under the picture stay for a closer look at each color */
  function show(c) {
    var sp = tool.querySelector('.t3spin');
    tool.querySelectorAll('.t3pic img').forEach(function (im) { im.hidden = im.dataset.c !== c || (sp && c === 'red'); });
    if (sp) { sp.hidden = c !== 'red'; if (!sp.hidden) try { sp.play(); } catch (e) {} }
    grid.querySelectorAll('.t3sw').forEach(function (x) { x.classList.toggle('on', x.dataset.c === c); });
    var cn = cl && cl.querySelector('[data-cn]'); if (cn) cn.textContent = name(c);
  }
  function name(c) { for (var i = 0; i < sw.length; i++) if (sw[i].c === c) return sw[i].n; return c; }
  function qty() { var on = tool.querySelector('.t3pk.on'); return on ? parseInt(on.dataset.q, 10) : 1; }
  function render() {
    var q = qty(), pk = tool.querySelector('.t3pk.on');
    while (picks.length < q) picks.push(picks[picks.length - 1]);
    picks = picks.slice(0, q);
    if (pk && pk.nextSibling !== rows) pk.parentNode.insertBefore(rows, pk.nextSibling);
    rows.hidden = false;
    rows.innerHTML = '<span class="t3rh">' + (q < 2 ? 'Choose your color' : 'Choose a color for each breaker <em>Mix and match ' + q + '</em>') + '</span>';
    picks.forEach(function (c, i) {
      var row = document.createElement('div'); row.className = 't3row';
      var tag = document.createElement('span'); tag.className = 't3rt';
      tag.innerHTML = (q < 2 ? 'Color' : 'Breaker ' + (i + 1)) + '<b>' + name(c) + '</b>';
      var strip = document.createElement('div'); strip.className = 't3rs';
      sw.forEach(function (s) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 't3ms' + (s.c === c ? ' on' : '');
        b.setAttribute('aria-label', (q < 2 ? '' : 'Breaker ' + (i + 1) + ': ') + s.n); b.title = s.n;
        b.innerHTML = '<img src="' + s.img + '" alt="">';
        b.addEventListener('click', function () { picks[i] = s.c; show(s.c); render(); });
        strip.appendChild(b);
      });
      row.appendChild(tag); row.appendChild(strip); rows.appendChild(row);
    });
  }
  tool.querySelectorAll('.t3pk').forEach(function (p) { p.addEventListener('click', function () { setTimeout(render, 0); }); });
  /* on Single, a big swatch also picks the color */
  grid.querySelectorAll('.t3sw').forEach(function (b) { b.addEventListener('click', function () { if (qty() < 2) { picks[0] = b.dataset.c; render(); } }); });
  /* colors for the cart: one display name per breaker */
  tool._colors = function () { return picks.slice(0, qty()).map(name); };
  render();
})();

/* Help form on phones: open it from the Tell Us button, or when a "Tell us" link jumps to the help section. */
(function () {
  var sec = document.getElementById('v3help'), btn = sec && sec.querySelector('[data-hopen]');
  if (!sec || !btn) return;
  function open(scroll) {
    sec.classList.add('hopened'); btn.setAttribute('aria-expanded', 'true');
    if (scroll) { var f = document.getElementById('v3form'); if (f) setTimeout(function () { f.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50); }
  }
  btn.addEventListener('click', function () { open(true); });
  document.addEventListener('click', function (e) { var a = e.target.closest('a[href="#v3help"]'); if (a) open(false); });
  if (location.hash === '#v3help' || location.hash === '#v3form') open(false);
})();

/* Acerill quirk (Oct 2026): a photo starts uploading the moment it is picked ("Uploading..."). If Send is tapped before that
   finishes, the form never sends. So when Send is tapped mid-upload, show a status line, wait for the upload, then send once. */
(function () {
  var app = document.getElementById('v3form');
  if (!app) return;
  var busy = false;
  function done() { return !!app.querySelector('.confirmation-box'); }
  function uploading() { return /Uploading\.\.\./.test(app.textContent); }
  function say(t) {
    var b = app.querySelector('.cf-btn-block'), n = app.querySelector('.hsending');
    if (!n && b) { n = document.createElement('p'); n.className = 'hsending'; b.parentNode.appendChild(n); }
    if (n) { n.textContent = t || ''; n.hidden = !t; }
  }
  app.addEventListener('click', function (e) {
    var b = e.target.closest('.cf-btn-block');
    if (!b || busy || !e.isTrusted || !uploading()) return;
    busy = true;
    say('Uploading your photo. Please wait, this can take a moment.');
    var tries = 0, sent = false;
    var iv = setInterval(function () {
      tries++;
      if (done() || tries > 240) { clearInterval(iv); busy = false; say(''); return; }   /* stop on success, or after 2 minutes */
      if (!sent && !uploading()) {
        sent = true; say('Sending to our team...');
        setTimeout(function () { var btn = app.querySelector('.cf-btn-block'); if (btn && !done()) btn.click(); }, 700);
      }
    }, 500);
  }, true);
})();

/* Hero loop: the poster photo paints first; the 7 s loop starts right after the page finishes loading. */
(function () {
  var v = document.querySelector('.awp-home #v3hp video.loop[data-defer]');
  if (!v) return;
  function go() {
    var hp = document.getElementById('v3hp');
    if (hp && hp.classList.contains('playing')) return;
    v.muted = true; v.playsInline = true; v.preload = 'auto';
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  if (document.readyState === 'complete') setTimeout(go, 300);
  else window.addEventListener('load', function () { setTimeout(go, 300); });
})();
